import { getApiClient } from '../../api/client';
import type { components } from '../../api/schema';

export type ScoringConfig = components['schemas']['ScoringConfig'];
export type ScoringConfigUpdate = components['schemas']['ScoringConfigUpdate'];

function apiError(prefix: string, error: unknown): Error {
  const detail =
    typeof error === 'object' &&
    error !== null &&
    'detail' in error &&
    typeof error.detail === 'string'
      ? error.detail
      : null;
  return new Error(detail ? `${prefix}: ${detail}` : prefix);
}

export async function getScorecardThresholds(): Promise<ScoringConfig> {
  const { data, error } = await getApiClient().GET('/scorecard-thresholds');
  if (error) throw apiError('Scorecard thresholds could not be loaded', error);
  if (!data) throw new Error('Scorecard thresholds could not be loaded: empty response');
  return data;
}

export async function updateScorecardThresholds(body: ScoringConfigUpdate): Promise<ScoringConfig> {
  const { data, error } = await getApiClient().PUT('/scorecard-thresholds', { body });
  if (error) throw apiError('Scorecard thresholds were not saved', error);
  if (!data) throw new Error('Scorecard thresholds were not saved: empty response');
  return data;
}
